import ModalSuccessSinistro from "./modalSuccessSinistro";

export default ModalSuccessSinistro;
